export default [
  {
    path: '/contract',
    meta: {
      title: 'Document Verification',
    },
    component: () => import('@/modules/common/views/Private.vue'),
    children: [].concat({
      name: 'Contract',
      path: 'sign/:document_unique_key',
      meta: {
        title: 'Document',
      },
      component: () => import('@/modules/contract/views/Contract.vue'),
    }),
  },
];
